import { LorenzFormLayoutEnum } from '../enums/lorenz-form-layout.enum';

// Hier werden die Optionen definiert, mit denen man die ANZEIGE der LorenzForm-Components steuern kann.

// Diese Werte müssen immer bis in die LorenzFormControlComponents durchgereicht werden!

export interface LorenzFormComponentDisplayOptions {
	displayGroupHeaders?: boolean; // Schaltet die Anzeige der Gruppenüberschriften AUF DER OBERSTEN EBENE an oder aus. Die Gruppentexte sind davon nicht betroffen!
	highlightChanges?: boolean; // Markierung von Werteänderungen anzeigen oder nicht.
	layout?: LorenzFormLayoutEnum; // Das zu verwendende Layout.
	showErrorMessages?: boolean; // Fehlermeldungen anzeigen oder nicht.
}

// Benutze das hier für die DEFAULT-Werte.

export const LorenzFormComponentOptionsDefault: Required<LorenzFormComponentDisplayOptions> = {
	displayGroupHeaders: true,
	highlightChanges: true,
	layout: LorenzFormLayoutEnum.DEFAULT,
	showErrorMessages: true
};
